module.exports = __webpack_public_path__ + "img/Lakala.0e2718ee.png";